export const isEnumInclude = <T extends Record<string, string | number>>(
  object: T,
  value: any
): value is T[keyof T] => {
  return Object.values(object).includes(value);
};
